import { Navigate, useParams, generatePath } from 'react-router-dom';

/** Redirects any dynamic routes, can be used like `<RedirectRoute to="new-url/:id" />` */
const RedirectRoute = (props: { to: string }) => {
    const { to } = props;
    const params = useParams();
    const redirectWithParams = generatePath(to, params);
    return <Navigate to={redirectWithParams} />;
};

export default RedirectRoute;
